//TODO: Este documento se crea para las apis que se ocuapn de paquetes V2 del mayorista

import axios from "axios"
import { APIURL } from "./../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"
const urlPackage = "Package"

//* Metodo para obtener los preoveedores terrestres listado
//* GET /api/Package/V2/Supplier/Ground/List
export const getProveedorTerrestreLista = async () => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Supplier/Ground/List`, {
        headers: getCabecera()
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}
//* Metodo para obtener los preoveedores terrestres paginado
//* GET /api/Package/V2/Supplier/Ground/{idProveedor}/{Pagina}/{Registros}
export const getProveedorTerrestreAll = async ({ idProveedor, Pagina, Registros }) => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Supplier/Ground/${idProveedor}/${Pagina}/${Registros}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return {}
        // return getError(Error);
    })
}
//* Metodo para crear un nuevo proveedor terrestre
//* POST /api/Package/V2/Supplier/Ground
export const newProveedorTerrestre = async ({ IdProveedor, IdMoneda, ClavePaquete, Nombre, PrecioNeto, Itinerario, Incluye, NoIncluye }) => {
    return await axios.post(`${APIURL}/${urlPackage}/V2/Supplier/Ground`, {
        IdProveedor,
        IdMoneda,
        ClavePaquete,
        Nombre,
        PrecioNeto,
        Itinerario,
        Incluye,
        NoIncluye,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para actulizar un proveedor terrestre
//* PUT /api/Package/V2/Supplier/Ground/{IdPaqueteProveedorTerrestre}
export const updateProveedorTerrestre = async ({ Incluye, NoIncluye, IdPaqueteProveedorTerrestre, IdProveedor, IdMoneda, ClavePaquete, Nombre, PrecioNeto, Itinerario, Estatus }) => {
    return await axios.put(`${APIURL}/${urlPackage}/V2/Supplier/Ground/${IdPaqueteProveedorTerrestre}`, {
        IdProveedor,
        IdMoneda,
        ClavePaquete,
        Nombre,
        PrecioNeto,
        Itinerario,
        Incluye,
        NoIncluye,
        Estatus,
    }, {
        headers: getCabecera(),
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return getError(Error);
    })
}

//* Metodo para consultar los circuitos por proveedor terrestre
//* GET /api/Package/V2/Circuit/{IdPaqueteProveedorTerrestre}
export const getCircuitosIdProveedorTerrestre = async ({ IdPaqueteProveedorTerrestre }) => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Circuit/${IdPaqueteProveedorTerrestre}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return []
        // return getError(Error);
    })
}
//* Metodo para crear un nuevo circuito
//* POST /api/Package/V2/Circuit
export const newCircuito = async ({ IdPaqueteProveedorTerrestre, ClaveCircuito, FechaInicio, FechaFin, Disponibilidad, Dias, Noches, Suplemento }) => {
    return await axios.post(`${APIURL}/${urlPackage}/V2/Circuit`, {
        IdPaqueteProveedorTerrestre,
        ClaveCircuito,
        FechaInicio,
        FechaFin,
        Disponibilidad,
        Dias,
        Noches,
        Suplemento,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para actulizar un nuevo circuito
//* PUT /api/Package/V2/Circuit/{IdPaqueteCircuito}
export const putCircuito = async ({ IdPaqueteCircuito, IdPaqueteProveedorTerrestre, ClaveCircuito, FechaInicio, FechaFin, Disponibilidad }) => {
    return await axios.put(`${APIURL}/${urlPackage}/V2/Circuit/${IdPaqueteCircuito}`, {
        IdPaqueteProveedorTerrestre,
        ClaveCircuito,
        FechaInicio,
        FechaFin,
        Disponibilidad
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para consultar los paquetes mayoristas listado
//* GET /api/Package/V2/Wholesaler/List 
export const getPaquetesMayoristaAllLista = async () => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Wholesaler/List`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return {}
        // return getError(Error);
    })
}
//* Metodo para consultar los paquetes mayoristas paginado
//* GET /api/Package/V2/Wholesaler
export const getPaquetesMayoristaAll = async ({ Pagina, Registros }) => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Wholesaler/${Pagina}/${Registros}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return {}
        // return getError(Error);
    })
}
//* Metodo para alta de paquete mayorista
//* POST /api/Package/V2/Wholesaler
export const newPaqueteMayorista = async ({
    IdPaqueteProveedorTerrestre,
    IdMoneda,
    ClavePaquete,
    Nombre,
    PrecioPublico,
    TipoCambioPrevisto,
    IdProveedorGrupoPaquete,
}) => {
    return await axios.post(`${APIURL}/${urlPackage}/V2/Wholesaler`, {
        IdPaqueteProveedorTerrestre,
        IdMoneda,
        ClavePaquete,
        Nombre,
        PrecioPublico,
        TipoCambioPrevisto,
        IdProveedorGrupoPaquete,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para actulizar el paquete mayorista
//* PUT /api/Package/V2/Wholesaler/{IdPaqueteMayorista}
export const actualizaPaqueteMayorista = async ({
    IdPaqueteMayorista,
    IdPaqueteProveedorTerrestre,
    IdMoneda,
    ClavePaquete,
    Nombre,
    PrecioPublico,
    TipoCambioPrevisto,
    Estatus,
    IdProveedorGrupoPaquete,
}) => {
    return await axios.put(`${APIURL}/${urlPackage}/V2/Wholesaler/${IdPaqueteMayorista}`, {
        IdPaqueteProveedorTerrestre,
        IdMoneda,
        ClavePaquete,
        Nombre,
        PrecioPublico,
        TipoCambioPrevisto,
        Estatus,
        IdProveedorGrupoPaquete,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

//* Metodo para agregar un vuelo aun circuito
//* POST /api/Package/V2/Circuit/Fligth
export const newAereoCircuito = async ({ IdPaqueteCircuito, IdVueloProveedor }) => {
    return await axios.post(`${APIURL}/${urlPackage}/V2/Circuit/Fligth`, {
        IdPaqueteCircuito,
        IdVueloProveedor
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return []
        // return getError(Error);
    })
}

//* Metodo para eliminar un vuelo aun cirucuto
//* DELETE /api/Package/V2/Circuit/Fligth/{IdPaqueteCircuitoVuelo} 
export const deleteAereoCircuito = async ({ IdPaqueteCircuitoVuelo }) => {
    return await axios.delete(`${APIURL}/${urlPackage}/V2/Circuit/Fligth/${IdPaqueteCircuitoVuelo}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return []
        // return getError(Error);
    })
}
//* Metodo para consulta de paquetes por idVuelo paginado
//* GET /api/Package/V2/Ground/Flight/{IdVueloProveedor}/{Pagina}/{Registros} 
export const getTerrestresByIdVuelo = async ({ IdVueloProveedor, Pagina, Registros }) => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Ground/Flight/${IdVueloProveedor}/${Pagina}/${Registros}`, {
        headers: getCabecera(),
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return {}
    })
}

//* Metodo para insertar una imagen al paquete mayorista
//* POST /api/Package/V2/Wholesaler/Gallery
export const newImagenTipoPaqueteMayorista = async ({ IdPaqueteMayorista, IdTipoImagen, ImagenBase64, ExtensionImagen }) => {
    return await axios.post(`${APIURL}/${urlPackage}/V2/Wholesaler/Gallery`, {
        IdPaqueteMayorista,
        IdTipoImagen,
        ImagenBase64,
        ExtensionImagen,
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para actulizar una imagen al paquete mayorista
//* PUT /api/Package/V2/Wholesaler/{IdPaqueteMayorista}
export const updateImagenTipoPaqueteMayorista = async ({ IdPaqueteCircuito, IdVueloProveedor }) => {
    return await axios.put(`${APIURL}/${urlPackage}/V2/Wholesaler/{IdPaqueteMayorista}`, {
        IdPaqueteCircuito,
        IdVueloProveedor
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}
//* Metodo para eliminar una imagen al paquete mayorista
//* DELETE /api/Package/V2/Gallery/{IdPaqueteMayoristaImagen}
export const deleteImagenTipoPaqueteMayorista = async ({ IdPaqueteMayoristaImagen }) => {
    return await axios.delete(`${APIURL}/${urlPackage}/V2/Wholesaler/Gallery/${IdPaqueteMayoristaImagen}`, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}

//* Metodo apra consulta de imagenes por tipo imagen del paquete mayoristaa
//* GET /api/Package/V2/Wholesaler/Gallery/{ClavePaquete}/{IdTipoImagen}
export const getGaleriaTipoPaqueteMayorista = async ({ tipo, clavePaquete }) => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Wholesaler/Gallery/${clavePaquete}/${tipo}`, {
        headers: getCabecera(),
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}

//* Metodo alta paquete terrestre hotel
//* POST /api/Package/V2/Supplier/Ground/Hotel
export const postHotelPaqueteTerrestre = async ({ idPaqueteTerrestre, idHotel, suplemento }) => {
    return await axios.post(`${APIURL}/${urlPackage}/V2/Supplier/Ground/Hotel`,
        {
            "IdPaqueteProveedorTerrestre": idPaqueteTerrestre,
            "IdHotel": idHotel,
            "Suplemento": suplemento
        },
        {
            headers: getCabecera(),
        }
    ).then(Response => {
        return Response.data
    }).catch(Error => {
        return getError(Error)
    })
}
//* Metodo consulta paquete terrestre hotel
//* GET /api/Package/V2/Supplier/Ground/Hotel/{IdPaqueteProTer}
export const getHotelPaqueteTerrestreById = async ({ idPaqueteTerrestre }) => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Supplier/Ground/Hotel/${idPaqueteTerrestre}`, {
        headers: getCabecera(),
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}
//* Eliminar paquete hotel terrestre
//* DELETE /api/Package/V2/Supplier/Ground/Hotel/{IdPaqueteProTerTipoHotel}
export const deleteHotelPaqueteTerrestreById = async ({ idPaqueteTerrestreHotel }) => {
    return await axios.delete(`${APIURL}/${urlPackage}/V2/Supplier/Ground/Hotel/${idPaqueteTerrestreHotel}`, {
        headers: getCabecera()
    }).then(Response => Response.data)
        .catch(Error => getError(Error))
}

//* Metodo alta paquete terrestre plaza
//* POST post /api/Package/V2/Supplier/Ground/Place
export const postPlazaPaqueteTerrestre = async ({ idPaqueteTerrestre, idTipoPlaza, suplemento, disponibilidad }) => {
    return await axios.post(`${APIURL}/${urlPackage}/V2/Supplier/Ground/Place`,
        {
            "IdPaqueteProveedorTerrestre": idPaqueteTerrestre,
            "IdTipoPlaza": idTipoPlaza,
            "Suplemento": suplemento,
            "Disponibilidad": disponibilidad
        },
        {
            headers: getCabecera(),
        }
    )
        .then(Response => Response.data)
        .catch(Error => getError(Error))
}
//* Metodo consulta paquete terrestre plaza
//* GET /api/Package/V2/Supplier/Ground/Place/{IdPaqueteProTer}
export const getPlazaPaqueteTerrestreById = async ({ idPaqueteTerrestre }) => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Supplier/Ground/Place/${idPaqueteTerrestre}`, {
        headers: getCabecera(),
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}
//* Eliminar paquete plaza terrestre
//* DELETE /api/Package/V2/Supplier/Ground/Place/{IdPaqueteProTerTipoPlaza}
export const deletePlazaPaqueteTerrestreById = async ({ idPaqueteTerrestrePlaza }) => {
    return await axios.delete(`${APIURL}/${urlPackage}/V2/Supplier/Ground/Place/${idPaqueteTerrestrePlaza}`, {
        headers: getCabecera()
    }).then(Response => Response.data)
        .catch(Error => getError(Error))
}

//* Metodo alta paquete terrestre Extra
//* POST /api/Package/V2/Supplier/Ground/Extra
export const postExtraPaqueteTerrestre = async ({ idPaqueteTerrestre, idExtra, suplemento, descripcion }) => {
    return await axios.post(`${APIURL}/${urlPackage}/V2/Supplier/Ground/Extra`,
        {
            "IdPaqueteProveedorTerrestre": idPaqueteTerrestre,
            "IdExtra": idExtra,
            "Suplemento": suplemento,
            "Descripcion": descripcion
        },
        {
            headers: getCabecera(),
        }
    )
        .then(Response => Response.data)
        .catch(Error => getError(Error))
}
//* Metodo consulta paquete terrestre Extra
//* GET /api/Package/V2/Supplier/Ground/Extra/{IdPaqueteProTer}
export const getExtraPaqueteTerrestreById = async ({ idPaqueteTerrestre }) => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Supplier/Ground/Extra/${idPaqueteTerrestre}`, {
        headers: getCabecera(),
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}
//* Eliminar paquete Extra terrestre
//* DELETE /api/Package/V2/Supplier/Ground/Extra/{IdPaqueteProTerTipoExtra}
export const deleteExtraPaqueteTerrestreById = async ({ idPaqueteTerrestreExtra }) => {
    return await axios.delete(`${APIURL}/${urlPackage}/V2/Supplier/Ground/Extra/${idPaqueteTerrestreExtra}`, {
        headers: getCabecera()
    }).then(Response => Response.data)
        .catch(Error => getError(Error))
}

//* Metodo para crear tipo extra terrestre
//* PUT /api/Package/V2/ExtraHistoric
export const newTipoExtraTerrestre = async ({ idCatExtra, idExtra, imagen, extencion }) => {
    return await axios.put(`${APIURL}/${urlPackage}/V2/ExtraHistoric`, {
        idCatExtra, idExtra, imagen, extencion
    }, {
        headers: getCabecera()
    }).then((Response) => {
        return Response.data
    }).catch((Error) => {
        return getError(Error);
    })
}


//* Metodo alta paquete terrestre City
//* POST /api/Package/V2/Supplier/Ground/City
export const postCiudadPaqueteTerrestre = async ({ idPaqueteTerrestre, idCiudad }) => {
    return await axios.post(`${APIURL}/${urlPackage}/V2/Supplier/Ground/City`,
        {
            "IdPaqueteProveedorTerrestre": idPaqueteTerrestre,
            "IdCiudad": idCiudad
        },
        {
            headers: getCabecera(),
        }
    )
        .then(Response => Response.data)
        .catch(Error => getError(Error))
}
//* Metodo consulta paquete terrestre ciudad
//* GET /api/Package/V2/Supplier/Ground/City/{IdPaqueteProTer}
export const getCiudadPaqueteTerrestreById = async ({ idPaqueteTerrestre }) => {
    return await axios.get(`${APIURL}/${urlPackage}/V2/Supplier/Ground/City/${idPaqueteTerrestre}`, {
        headers: getCabecera(),
    }).then(Response => {
        return Response.data
    }).catch(Error => {
        return []
    })
}
//* Eliminar paquete ciudad terrestre
//* DELETE /api/Package/V2/Supplier/Ground/City/{IdPaqueteProTerTipoCiudad}
export const deleteCiudadPaqueteTerrestreById = async ({ idPaqueteTerrestreCiudad }) => {
    return await axios.delete(`${APIURL}/${urlPackage}/V2/Supplier/Ground/City/${idPaqueteTerrestreCiudad}`, {
        headers: getCabecera()
    }).then(Response => Response.data)
        .catch(Error => getError(Error))
}